import { LANGUAGE, LANGUAGES, type Language } from '@cmoh/shared'
import { useTranslation as useI18nTranslation } from 'react-i18next'
import type { I18nKey } from '@/lib/i18n/types'

/**
 * Hook to get the translation function with type safety
 * @returns The translation function
 */
export function useTranslation() {
  const { t } = useI18nTranslation()
  return (key: I18nKey, options?: Record<string, unknown>) => t(key, options)
}

/**
 * Hook to get current language and change language function
 * @returns Object with current language and changeLanguage function
 */
export function useLanguage() {
  const { i18n } = useI18nTranslation()

  const currentLanguage = LANGUAGES.includes(i18n.language as Language)
    ? (i18n.language as Language)
    : LANGUAGE.EN

  return {
    currentLanguage,
    changeLanguage: (lng: Language) => i18n.changeLanguage(lng),
    availableLanguages: LANGUAGES,
  }
}
